import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Menu, X, Phone, ChevronDown } from 'lucide-react';
import { Link, useLocation } from 'react-router-dom';
interface NavChild {
  title: string;
  url: string;
}
interface NavItem {
  title: string;
  url: string;
  children?: NavChild[];
}
const navLinks: NavItem[] = [{
  title: 'Programs',
  url: '/programs'
}, {
  title: 'Classes',
  url: '/classes',
  children: [{
    title: 'Taekwondo',
    url: '/classes/taekwondo'
  }, {
    title: 'Kickboxing',
    url: '/classes/kickboxing'
  }, {
    title: 'Homeschool',
    url: '/classes/homeschool'
  }, {
    title: 'Group & Corporate Self Defense Seminars',
    url: '/classes/self-defense-seminars'
  }, {
    title: 'Private Classes',
    url: '/classes/private-classes'
  }, {
    title: 'Our Classes Schedule',
    url: '/schedule'
  }, {
    title: 'Our Facility',
    url: '/facility'
  }]
}, {
  title: 'Benefits',
  url: '/benefits-for-children',
  children: [{
    title: 'Child Benefits',
    url: '/benefits-for-children'
  }, {
    title: 'Teen Benefits',
    url: '/benefits-for-teens'
  }, {
    title: 'Adult Benefits',
    url: '/benefits-for-adults'
  }, {
    title: 'Family Benefits',
    url: '/benefits-for-families'
  }, {
    title: 'Personal Safety',
    url: '/selfdefensetips'
  }]
}, {
  title: 'Midwest Cup 2026',
  url: '/midwest-cup-2026',
  children: [{
    title: 'Event Details',
    url: '/midwest-cup-2026'
  }, {
    title: 'Tournament Registration',
    url: '/midwest-cup-2026#registration'
  }]
}, {
  title: 'About',
  url: '/about'
}, {
  title: 'Forms',
  url: '/forms'
}, {
  title: 'Contact',
  url: '/contact'
}];
export function HomeNavMobileMenu() {
  const [isOpen, setIsOpen] = useState(false);
  const [openSubmenu, setOpenSubmenu] = useState<string | null>(null);
  const location = useLocation();
  const currentPath = location.pathname;
  // Close mobile menu when route changes
  useEffect(() => {
    setIsOpen(false);
    setOpenSubmenu(null);
  }, [location]);
  return <>
      {/* Mobile Menu Button */}
      <button onClick={() => setIsOpen(true)} className="md:hidden text-white p-2 hover:text-[#00D4FF] transition-colors" aria-label="Open menu" data-id="element-1186">
        <Menu size={28} data-id="element-1187" />
      </button>

      {/* Mobile Drawer */}
      <AnimatePresence data-id="element-1188">
        {isOpen && <>
            {/* Backdrop */}
            <motion.div initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} exit={{
          opacity: 0
        }} onClick={() => setIsOpen(false)} className="fixed inset-0 bg-black/80 backdrop-blur-sm z-40 md:hidden" data-id="element-1189" />

            {/* Drawer */}
            <motion.div initial={{
          x: '100%'
        }} animate={{
          x: 0
        }} exit={{
          x: '100%'
        }} transition={{
          type: 'spring',
          damping: 25,
          stiffness: 200
        }} className="fixed top-0 right-0 bottom-0 w-[280px] bg-[#1a1a1a] z-50 shadow-2xl border-l border-gray-800 flex flex-col" data-id="element-1190">
              <div className="p-6 flex justify-between items-center border-b border-gray-800" data-id="element-1191">
                <span className="text-white font-bold text-lg" data-id="element-1192">Menu</span>
                <button onClick={() => setIsOpen(false)} className="text-gray-400 hover:text-white transition-colors" data-id="element-1193">
                  <X size={24} data-id="element-1194" />
                </button>
              </div>

              <div className="flex-1 overflow-y-auto py-6 px-6 flex flex-col gap-4" data-id="element-1195">
                <Link to="/" onClick={() => setIsOpen(false)} className="text-lg font-medium text-gray-300 hover:text-[#00D4FF] transition-colors" data-id="element-1196">
                  Home
                </Link>
                {navLinks.map(link => <div key={link.title} data-id="element-1197">
                    {link.children ? <>
                        <a href="#" onClick={e => {
                  e.preventDefault();
                  setOpenSubmenu(openSubmenu === link.title ? null : link.title);
                }} className={`w-full text-left text-lg font-medium transition-colors flex items-center justify-between ${link.children.some(child => child.url === currentPath) ? 'text-[#00D4FF]' : 'text-gray-300 hover:text-[#00D4FF]'}`} data-id="element-1198">
                          {link.title}
                          <ChevronDown className={`w-4 h-4 transition-transform ${openSubmenu === link.title ? 'rotate-180' : ''}`} data-id="element-1199" />
                        </a>
                        <AnimatePresence data-id="element-1200">
                          {openSubmenu === link.title && <motion.div initial={{
                    height: 0,
                    opacity: 0
                  }} animate={{
                    height: 'auto',
                    opacity: 1
                  }} exit={{
                    height: 0,
                    opacity: 0
                  }} transition={{
                    duration: 0.2
                  }} className="overflow-hidden" data-id="element-1201">
                              <div className="pl-4 pt-2 space-y-2" data-id="element-1202">
                                {link.children.map(child => child.url ? <Link key={child.url} to={child.url} onClick={() => setIsOpen(false)} className={`block py-2 text-sm font-medium transition-colors ${currentPath === child.url ? 'text-[#00D4FF]' : 'text-gray-400 hover:text-[#00D4FF]'}`} data-id="element-1203">
                                      {child.title}
                                    </Link> : <span key={child.title} className="block py-2 text-sm font-medium text-gray-500 cursor-default" data-id="element-1204">
                                      {child.title}
                                    </span>)}
                              </div>
                            </motion.div>}
                        </AnimatePresence>
                      </> : link.url ? <Link to={link.url} onClick={() => setIsOpen(false)} className={`text-lg font-medium transition-colors block ${currentPath === link.url ? 'text-[#00D4FF]' : 'text-gray-300 hover:text-[#00D4FF]'}`} data-id="element-1205">
                        {link.title}
                      </Link> : <span className="text-lg font-medium text-gray-500 cursor-default block" data-id="element-1206">
                        {link.title}
                      </span>}
                  </div>)}
                <hr className="border-gray-800 my-2" data-id="element-1207" />
                <Link to="/womens-self-defense-seminar-april-18-2026/p/womens-self-defense-workshop-toys-for-tots-toy-drive" onClick={() => setIsOpen(false)} className="text-[#00D4FF] font-semibold text-base hover:text-white transition-colors" data-id="element-1208">
                  Women's Self Defense Seminar April 18, 2026
                </Link>
                <hr className="border-gray-800 my-2" data-id="element-1209" />
                <Link to="/free-trial" onClick={() => setIsOpen(false)} className="bg-[#00D4FF] text-black py-3 rounded text-center font-bold uppercase tracking-wider hover:bg-[#33ddff] transition-colors block" data-id="element-1210">
                  Schedule Free Trial
                </Link>

                <div className="mt-auto pt-8" data-id="element-1211">
                  <div className="flex items-center gap-3 text-gray-400 mb-2" data-id="element-1212">
                    <Phone size={18} className="text-[#00D4FF]" data-id="element-1213" />
                    <span className="text-sm" data-id="element-1214">Call us today</span>
                  </div>
                  <p className="text-white font-medium text-lg" data-id="element-1215">
                    Bloomington, IL
                  </p>
                </div>
              </div>
            </motion.div>
          </>}
      </AnimatePresence>
    </>;
}